<template>
  <div class="unitindex">
    <el-card class="box-card">
      <!-- card header -->
      <div slot="header" class="clearfix" style="display: flex; align-items: center;">
        <span>员工基本工资信息列表</span>
        <div style="margin-left: auto;">
          <el-button
            class="tz-r tz-create-btn"
            type="primary"
            round
            @click="jump('/employee/create')"
            >添加</el-button
          >
          <el-button
            class="tz-r"
            type="success"
            round
            style="margin-left: 10px"
            :disabled="multipleSelection.length === 0"
            @click="showBatchDialog = true"
            >批量修改是否参与绩效</el-button
          >
        </div>
      </div>
      <!-- card header -->

      <!-- card content -->
      <!-- 筛选 -->
      <el-row>
        <el-col :span="6">
          <el-input
            placeholder="请输入员工姓名搜索"
            v-model="personName"
            clearable
            class="input-with-select"
          >
            <i slot="prefix" class="el-input__icon el-icon-search"></i>
            <el-button
              slot="append"
              icon="el-icon-search"
              @click="userSearch"
            ></el-button>
          </el-input>
        </el-col>
      </el-row>
      <!-- 筛选 -->

      <!-- 表格 -->
      <el-table ref="multipleTable" :data="employeeList" border stripe style="width: 100%" :summary-method="getSummaries" show-summary @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="50" align="center"></el-table-column>
        <el-table-column label="姓名" prop="personName" align="center"></el-table-column>
        <el-table-column label="工号" prop="personId" align="center"></el-table-column>
        <el-table-column label="身份证号" prop="cardNo" width="180" align="center"></el-table-column>
        <el-table-column label="基本工资" prop="basePay" align="center"></el-table-column>
        <el-table-column label="职位工资" prop="postPay" align="center"></el-table-column>
        <el-table-column label="合计" prop="count" align="center"></el-table-column>
        <el-table-column label="是否参与绩效" align="center">
          <template slot-scope="scope">
            <span :style="{ color: scope.row.isPerformanceCalc === 1 ? '#67c23a' : '#f56c6c' }">{{
              scope.row.isPerformanceCalc === 1 ? '参与' : '不参与'
            }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" align="center">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="editFn(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="deleteFn(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 表格 -->

      <!-- 分页 -->
      <!-- <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination> -->
      <!-- 分页 -->
      <!-- card content -->
    </el-card>
    <!-- card -->

    <!-- 编辑弹框 -->
    <Edit
      :state="editState"
      @close="editState = false"
      :user="editUnit"
      @confirm="changeUnit"
    />
    <!-- 编辑弹框 end -->

    <!-- 批量修改弹框 -->
    <el-dialog title="批量修改是否参与绩效" :visible.sync="showBatchDialog" width="400px">
      <div style="margin-bottom: 12px;">
        已选择 <strong style="color: #409eff">{{ multipleSelection.length }}</strong> 人
      </div>
      <el-select v-model="batchTargetValue" placeholder="请选择" style="width: 100%">
        <el-option :value="1" label="参与"></el-option>
        <el-option :value="2" label="不参与"></el-option>
      </el-select>
      <span slot="footer">
        <el-button @click="showBatchDialog = false">取消</el-button>
        <el-button type="primary" @click="confirmBatchUpdate">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { pageList, deleteWages, updateWages, batchUpdatePerformanceCalc } from '@/api/employeesalary'
import Edit from './components/Edit'
export default {
  components: {
    Edit
  },
  data() {
    return {
      page: 1, //当前页
      size: '10',
      total: 100,
      personName: '', // 员工姓名
      editState: false,
      editUnit: {},
      employeeList: [], // 表格数据
      multipleSelection: [], // 复选框选中行
      showBatchDialog: false, // 批量修改弹框
      batchTargetValue: 1, // 批量修改目标值
    }
  },
  methods: {
    // 合计行
    getSummaries(param) {
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计'
          return
        }
        const values = data.map((item) => Number(item[column.property]))
        if (
          column.property &&
          column.property != 'personName' &&
          column.property != 'personId' &&
          column.property != 'cardNo'
        ) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr)
            if (!isNaN(value)) {
              return prev + curr
            } else {
              return prev
            }
          }, 0)
          sums[index] = sums[index].toLocaleString()
        } else {
          sums[index] = '--'
        }
      })
      return sums
    },
    // 列表
    getEmployeeList() {
      let params = {
        personName: this.personName
        // pageSize: this.size,
        // pageNum: this.page
      }
      pageList(params).then((res) => {
        if (res.code == 200) {
          console.log(res.data, '信息列表')
          let infoArr = res.data.list
          // this.total = res.data.total
          this.employeeList = infoArr
        }
      })
    },
    // 编辑
    changeUnit(infos) {
      console.log(infos)
      this.$loading({
        text: '单位信息更新中'
      })
      let updateparams = {
        ...infos
      }
      updateWages(updateparams).then((res) => {
        console.log(res.data, '更新')
        this.$loading().close()
        if (res.code == 200) {
          this.$message({
            message: '更新成功',
            type: 'success'
          })
          this.getEmployeeList()
        } else {
          this.$message({
            type: 'error',
            message: '更新失败!'
          })
        }
        this.editState = false
      })
    },
    // 删除
    deleteFn(row) {
      console.log('删除', row)
      this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let delparams = {
            id: row.id
          }
          deleteWages(delparams).then((res) => {
            console.log(res, '删除')
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: '删除成功!'
              })
              this.getEmployeeList()
            } else {
              this.$message({
                type: 'error',
                message: '删除失败!'
              })
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 模糊查询
    userSearch() {
      this.page = 1
      this.getEmployeeList()
    },
    // 编辑
    editFn(row) {
      this.editUnit = JSON.parse(JSON.stringify(row))
      this.editState = true
    },
    // 复选框选中变化
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 批量修改确认
    confirmBatchUpdate() {
      if (this.batchTargetValue == null) {
        this.$message({ type: 'warning', message: '请选择是否参与绩效' })
        return
      }
      var batchList = this.multipleSelection.map(function (item) {
        return {
          id: item.id,
          isPerformanceCalc: this.batchTargetValue
        }
      }, this)
      this.$loading({ text: '保存中' })
      batchUpdatePerformanceCalc(batchList).then((res) => {
        this.$loading().close()
        this.showBatchDialog = false
        if (res.code == 200) {
          this.$message({ type: 'success', message: '修改成功' })
          this.getEmployeeList()
        } else {
          this.$message({ type: 'error', message: '修改失败' })
        }
      })
    }
  },
  mounted() {
    this.getEmployeeList()
  }
}
</script>

<style lang="scss" scoped>
::v-deep.el-table .el-table__footer-wrapper .cell {
  // text-align: center;
  color: red;
  font-size: 16px;
}
</style>
